import { render, staticRenderFns } from "./CustomPatternEdit.vue?vue&type=template&id=28cd33de"
import script from "./CustomPatternEdit.vue?vue&type=script&lang=js"
export * from "./CustomPatternEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports